import { render, staticRenderFns, recyclableRender, components } from "./vip.vue?vue&type=template&id=4d3f67b0&scoped=true&"
var renderjs
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&id=4d3f67b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f67b0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/vip.vue"
export default component.exports